<template>
  <v-container fluid class="admin-page">
      <v-row class="justify-space-between">
        <v-col
        cols="7"
        >
            <h2>{{ formType.text }} Order</h2>
        </v-col>
        <v-col cols="2">
            <v-btn type="submit" class="text--futura text--white text-capitalize" dark block @click.prevent="saveOrder()" :loading="buttonLoading" :disabled="buttonLoading">
                {{ formType.value == 'new' ? 'Save' : 'Update' }}
                <template v-slot:loader>
                    <v-progress-circular
                        indeterminate
                        color="black"
                    ></v-progress-circular>
                </template>
            </v-btn>
        </v-col>
      </v-row>
      <v-container fluid class="crystal-admin-form">
        <v-row class="justify-space-around">
                <v-col cols="5">
                    <label>Customer Name: </label>
                    <v-text-field
                        solo
                        placeholder="Enter Customer name"
                        v-model="order.Customer.fullName"
                    ></v-text-field>
                    <label>Customer Contact</label>
                    <v-text-field
                        solo
                        placeholder="Enter Customer Phone Number"
                        prefix="+62 |"
                        v-model="orderContact"
                    ></v-text-field>
                    <label>Shipment Address: </label>
                    <v-textarea
                        solo
                        placeholder="Shipment Address"
                        v-model="order.ShiptoAddress"
                    ></v-textarea>
                    <label>Shipment Province: </label>
                    <v-autocomplete
                        solo
                        placeholder="Shipment Province"
                        v-model="order.province_id"
                        :items="provinces"
                        item-text="name"
                        item-value="province_id"
                    ></v-autocomplete>
                    <div
                        v-if="order.province_id"
                    >
                        <label>Shipment City: </label>
                        <v-autocomplete
                            solo
                            placeholder="Shipment City"
                            v-model="order.city_id"
                            :items="cities"
                            item-text="name"
                            item-value="city_id"
                        >
                            <template slot="selection" slot-scope="data">
                                <!-- HTML that describe how select should render selected items -->
                                {{ data.item.type }} {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                                <!-- HTML that describe how select should render items when the select is open -->
                                {{ data.item.type }} {{ data.item.name }}
                            </template>
                        </v-autocomplete>
                    </div>
                    <label>Postal Code:</label>
                    <v-text-field
                        solo
                        placeholder="Enter Postal Code"
                        v-model="order.postal_code"
                    ></v-text-field>
                    <label>Shipment Status: </label>
                    <v-select
                        solo
                        :items="shipment_statuses"
                        item-text="label"
                        item-value="value"
                        label="Choose Status"
                        v-model="order.ShipStatus"
                    ></v-select>
                    <label>Payment Status: </label>
                    <v-select
                        solo
                        :items="order_statuses"
                        label="Choose Status"
                        v-model="order.OrderStatus"
                    ></v-select>
                    <!-- <label>Courier Tracking Code: </label>
                    <v-text-field
                        solo
                        placeholder="Courier Tracking Code"
                    ></v-text-field> -->
                    <!-- <label>AR Account: </label>
                    <v-text-field
                        solo
                        placeholder="Enter AR Account"
                    ></v-text-field> -->
                    <v-row class="justify-space-between align-center">
                        <v-col cols="3">
                            <label>Dropshipper</label>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox
                                v-model="dropshipper_check"
                            >
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <div
                        v-if="dropshipper_check"
                    >
                        <label>Dropshipper Name:</label>
                        <v-text-field 
                            solo
                            placeholder="Enter Name"
                        >
                        </v-text-field>
                        <label>Dropshipper Contact:</label>
                        <v-text-field 
                            solo
                            placeholder="Enter phone number"
                            prefix="+62 |"
                        >
                        </v-text-field>
                    </div>
                </v-col>
                <v-col cols="5">
                    <label>Order Date: </label>
                    <v-row>
                        <v-col
                        cols="12"
                        >
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="order_date"
                                transition="scale-transition"
                                offset-y
                                min-width="350px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="order_date"
                                    label="Order Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    append-icon="mdi-calendar"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="order_date"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(order_date)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <label>Ship From</label>
                    <v-autocomplete
                        solo
                        :items="warehouses"
                        placeholder="Warehouse Location"
                        append-icon="mdi-magnify"
                        item-text="LocationName"
                        item-value="id"
                        v-model="order.ShipFromLocationId"
                    >    
                    </v-autocomplete>
                    <label>Shipment Date: </label>
                    <v-row>
                        <v-col
                        cols="12"
                        >
                            <v-menu
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                :return-value.sync="shipment_date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="shipment_date"
                                    label="Shipment Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    append-icon="mdi-calendar"
                                    clearable
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="shipment_date"
                                    no-title
                                    scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu2 = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu2.save(shipment_date)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <label>Sales Type:</label>
                    <v-select
                        :items="sales_types"
                        solo
                        label="Choose Type"
                        v-model="order.sales_type"
                    >
                    </v-select>
                    <label>Customer Type:</label>
                    <v-select
                        :items="customer_types"
                        solo
                        label="Choose Type"
                        v-model="order.customer_type"
                    >
                    </v-select>
                    <label>Courier:</label>
                    <v-select
                        :items="couriers"
                        solo
                        label="Choose Couriers"
                        item-text="CourierCompany"
                        item-value="id"
                        v-model="order.DeliveryMethodId"
                    >
                    </v-select>
                    <label>External Invoice Number:</label>
                    <v-text-field
                        solo
                        placeholder="Enter Invoice Number"
                        v-model="order.invoice_no"
                    >
                    </v-text-field>
                    <label>Memo:</label>
                    <v-text-field
                        solo
                        placeholder="Enter Memo"
                        v-model="order.memo"
                    >
                    </v-text-field>
                </v-col>
        </v-row>
        <hr>
        <v-row class="justify-space-between align-center mb-2">
            <v-col cols="7">
                <h3 class="mb-0">Product Order List</h3>
            </v-col>
            <v-col cols="3" class="text-right" v-if="formType.value == 'new'">
                <v-btn
                    class="text--futura text-capitalize"
                    outlined
                    color="primary"
                    @click="orderDraftDialog = true"
                >
                    Order Draft
                </v-btn>
            </v-col>
        </v-row>
        <v-alert
            v-if="draftParseSummary || draftUnmatchedLines.length"
            class="mb-4"
            dense
            outlined
            :type="draftUnmatchedLines.length ? 'warning' : 'success'"
        >
            <div v-if="draftParseAverageConfidence !== null">
                Orders matched. Confidence: {{ draftParseAverageConfidence }}%. Please double check data.
            </div>
            <div v-if="draftParseSummary && draftParseSummary.notes">
                {{ draftParseSummary.notes }}
            </div>
            <div v-if="draftParseSummary && draftParseSummary.has_ppn" class="mt-1">
                PPN from the parsed draft is already included in item prices, so frontend tax has been reset to 0%.
            </div>
            <div v-if="draftUnmatchedLines.length" class="mt-1">
                Unmatched lines: {{ draftUnmatchedLines.join(' | ') }}
            </div>
        </v-alert>
        <v-container>
            <ProductOrder
                v-for="(product, index) in order.OrderLine.items"
                :key="product.id"
                :index="index"
                :product="product"
                :formType="formType"
                @deleteProduct="deleteProduct"
                @updateProduct="updateProduct"
            />
        </v-container>
        <v-row class="justify-center">
            <v-col cols="2">
                <v-btn type="submit" class="text--futura text--white text-capitalize" dark block @click.prevent="addProduct()">
                    + Add Product
                </v-btn>
            </v-col>
        </v-row>
        <hr>
        <v-row class="flex-column align-end">
            <v-col cols="4">
                <span>Total Quantity : {{ quantity }}</span>
            </v-col>
            <v-col cols="4">
                <span>Sub Total : {{ formatHarga(price_total) }}</span>
            </v-col>
            <v-col cols="4">
                <span>
                    Tax
                    <v-select
                        v-model="order.tax"
                        dense
                        :items="taxes"
                        item-value="value"
                        item-text="text"
                        autowidth
                        :disabled="draftParseHasPpn"
                    ></v-select>
                    : {{ tax }}
                </span>
            </v-col>
            <v-col cols="4">
                <span>Delivery Fee : <v-text-field v-model="order.delivery_fee"></v-text-field> </span>
            </v-col>
            <v-col cols="4">
                <span><b>Total : {{ formatHarga(grand_total) }}</b></span>
            </v-col>
        </v-row>
      </v-container>
      <v-row class="justify-end">
          <v-col cols="2">
              <v-btn type="submit" class="text--futura text--white text-capitalize" dark block @click.prevent="saveOrder()" :loading="buttonLoading" :disabled="buttonLoading">
                {{ formType.value == 'new' ? 'Save' : 'Update' }}
                <template v-slot:loader>
                    <v-progress-circular
                        indeterminate
                        color="black"
                    ></v-progress-circular>
                </template>
              </v-btn>
          </v-col>
      </v-row>
      <v-dialog v-model="orderDraftDialog" max-width="720">
          <v-card>
              <v-card-title class="text-h6">
                  Parse Order Draft
              </v-card-title>
              <v-card-text>
                  <v-alert
                      v-if="draftParseError"
                      dense
                      outlined
                      type="error"
                      class="mb-4"
                  >
                      {{ draftParseError }}
                  </v-alert>
                  <v-textarea
                      v-model="orderDraftText"
                      outlined
                      rows="10"
                      label="Paste customer order text"
                      placeholder="2x Salmon Skin 100gr @45.000&#10;1 Tuna Mayo @55.000&#10;PPN 11%&#10;Tolong kirim hari ini"
                  ></v-textarea>
                  <div class="text-caption grey--text text--darken-1">
                      Parsed rows will replace the current product order list.
                  </div>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="closeOrderDraftDialog()" :disabled="draftParseLoading">
                      Cancel
                  </v-btn>
                  <v-btn
                      color="primary"
                      class="text-capitalize"
                      @click="parseOrderDraft()"
                      :loading="draftParseLoading"
                      :disabled="draftParseLoading"
                  >
                      Parse Draft
                  </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import ProductOrder from '@/components/ProductOrder.vue'
import server from '../api'

export default {
    name: 'OrderForm',
    components: {
        ProductOrder
    },
    props: {
        formType: {
            type: Object,
            default: () => {
                return {
                    text: 'Add New',
                    value: 'new'
                }
            }
        },
        buttonLoading: {
            type: Boolean,
            default: false
        },
        order: {
            type: Object,
            default: () => {
                return {
                    city_id: '',
                    province_id: '',
                    ShiptoAddress: '',
                    ShipStatus: 'Processed',
                    OrderStatus: 'payment_pending',
                    ShipFromLocationId: '',
                    order_date: new Date().toISOString().substr(0, 10),
                    shipment_date: new Date().toISOString().substr(0, 10),
                    DeliveryMethodId: 1,
                    sales_type: '',
                    customer_type: '',
                    Customer: {
                        fullName: '',
                        CustomerContact: {
                            contactNo: ''
                        }
                    },
                    OrderLine: {
                        items: []
                    },
                    tax: 0,
                    delivery_fee: 0,
                    memo: '',
                    invoice_no: ''
                }
            }
        },
    },
    data () {
        return {
            taxes: [
                { text: '0%', value: 0 },
                { text: '5 %', value: 5},
                { text: '11 %', value: 11},
                { text: '20 %', value: 20},
                { text: '30 %', value: 30}
            ],
            dropshipper_check: false,
            menu: false,
            menu2: false,
            selectedTax: 10,
            orderDraftDialog: false,
            orderDraftText: '',
            draftParseLoading: false,
            draftParseError: '',
            draftParseSummary: null,
            draftUnmatchedLines: [],
        }
    },
    methods: {
        saveOrder() {
            this.$emit('saveOrder', {
                grand_total: this.grand_total,
                subtotal: this.price_total
            })
        },
        addProduct () {
            let newProduct = {
                ItemId: '',
                qty: '',
                price: '',
                Item: {
                    name: ''
                }
            }
            this.order.OrderLine.items.push(newProduct)
        },
        deleteProduct(index) {
            this.order.OrderLine.items.splice(index, 1)
        },
        updateProduct (index, id, qty, price) {
            this.order.OrderLine.items[index].ItemId = id
            this.order.OrderLine.items[index].qty = qty
            this.order.OrderLine.items[index].price = price
        },
        closeOrderDraftDialog () {
            this.orderDraftDialog = false
            this.draftParseError = ''
        },
        async parseOrderDraft () {
            if (!this.orderDraftText || !this.orderDraftText.trim()) {
                this.draftParseError = 'order_text is required'
                return
            }

            this.draftParseLoading = true
            this.draftParseError = ''

            try {
                const { data } = await server.post('/orders/parse-text', {
                    order_text: this.orderDraftText.trim()
                }, {
                    headers: {
                        token: localStorage.token
                    }
                })

                const parsedItems = (data.items || []).map((item) => {
                    return {
                        ...item,
                        qty: Number(item.qty || 0),
                        price: Number(item.price || 0),
                        ItemId: item.ItemId || (item.Item && item.Item.id) || '',
                        Item: item.Item || { name: '' }
                    }
                })

                this.order.OrderLine.items = parsedItems
                this.draftParseSummary = data.summary || null
                this.draftUnmatchedLines = data.summary && Array.isArray(data.summary.unmatched_lines)
                    ? data.summary.unmatched_lines
                    : []

                if (this.draftParseHasPpn) {
                    this.order.tax = 0
                }

                this.orderDraftDialog = false
            } catch (err) {
                const responseData = err && err.response ? err.response.data : null
                const invalidItemIds = responseData && Array.isArray(responseData.invalid_item_ids)
                    ? ` (${responseData.invalid_item_ids.join(', ')})`
                    : ''

                this.draftParseError = responseData && responseData.message
                    ? `${responseData.message}${invalidItemIds}`
                    : err.message
            } finally {
                this.draftParseLoading = false
            }
        },
    },
    computed: {
        order_statuses () {
            return this.$store.state.order_statuses;
        },
        sales_types () {
            return this.$store.state.sales_types;
        },
        shipment_statuses () {
            return this.$store.state.shipment_statuses;
        },
        orderContact: {
            get () {
                return this.removeCountryCode(this.order.Customer.CustomerContact.contactNo);
            },
            set (value) {
                this.order.Customer.CustomerContact.contactNo = value;
            }
        },
        cities () {
            let province_id = this.order.province_id
            return this.$store.state.cities.filter(city => city.province_id == province_id)
        },
        quantity () {
            let quantity = 0;
            for(let i = 0; i < this.order.OrderLine.items.length; i++) {
                quantity += +this.order.OrderLine.items[i].qty
            }
            return quantity
        },
        products () {
            return this.$store.state.products
        },
        provinces () {
            return this.$store.state.provinces
        },
        draftParseHasPpn () {
            return Boolean(this.draftParseSummary && this.draftParseSummary.has_ppn)
        },
        draftParseAverageConfidence () {
            const items = this.order && this.order.OrderLine ? this.order.OrderLine.items || [] : []
            const confidenceValues = items
                .map(item => item && item.parse_metadata ? Number(item.parse_metadata.confidence) : null)
                .filter(value => Number.isFinite(value))

            if (!confidenceValues.length) return null

            const total = confidenceValues.reduce((sum, value) => sum + value, 0)
            return Math.round((total / confidenceValues.length) * 100)
        },
        tax () {
            return ((this.order.tax * 0.01) * this.price_total)
        },
        price_total () {
            let count = 0;
            let price_total = 0;
            for(let i = 0; i < this.order.OrderLine.items.length; i++) {
                let item_price = this.order.OrderLine.items[i].price ? this.order.OrderLine.items[i].price : this.order.OrderLine.items[i].Item.retail_price;
                count = this.order.OrderLine.items[i].qty * item_price;
                price_total += count
                count = 0
            }
            return price_total
        },
        grand_total () {
            return this.price_total + this.tax + (+this.order.delivery_fee)
        },
        couriers () {
            return this.$store.state.couriers
        },
        customer_types () {
            return this.$store.state.customer_types
        },
        warehouses () {
            return this.$store.state.warehouses
        },
        shipment_date: {
            get: function () {
                return this.order.shipment_date ? this.formatDate(this.order.shipment_date, 'YYYY-MM-DD') : '';
            },
            set: function (value) {
                this.order.shipment_date = value
            }
        },
        order_date: {
            get: function () {
                return this.order.order_date ? this.formatDate(this.order.order_date, 'YYYY-MM-DD') : this.formatDate(new Date(), 'YYYY-MM-DD');
            },
            set: function (value) {
                this.order.order_date = value
            }
        }
    },
    created () {
        this.$store.dispatch('getProducts')
        this.$store.dispatch('getProvinces')
        this.$store.dispatch('getCities')
        this.$store.dispatch('getCouriers')
        this.$store.dispatch('getWarehouses')
    }
}
</script>

<style>

</style>
